export default "__VITE_ASSET__CzoVSHqz__"